import { action } from 'easy-peasy';
import icd10CodeTypeOrderings from '~/constants/icd10CodeTypeOrderings';
import { IActionAddCarePlanIcd10Codes } from '../types';

const addCarePlanIcd10Codes: IActionAddCarePlanIcd10Codes = action((state, payload) => {
  state.items = [...payload, ...state.items].sort(
    (a, b) =>
      icd10CodeTypeOrderings.indexOf(a.typeId) - icd10CodeTypeOrderings.indexOf(b.typeId) ||
      a.icd10CodeName.localeCompare(b.icd10CodeName),
  );
});

export default addCarePlanIcd10Codes;
